/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Generate_Keynamehelper4Inputs */

const en_settings_reportingapikeys_generate_keynamehelper4 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Keynamehelper4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a descriptive, stable name, e.g. acme-pension-reporting-prod. Key names are unique per user.`)
};

/**
* | output |
* | --- |
* | "Use a descriptive, stable name, e.g. acme-pension-reporting-prod. Key names are unique per user." |
*
* @param {Settings_Reportingapikeys_Generate_Keynamehelper4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_keynamehelper4 = /** @type {((inputs?: Settings_Reportingapikeys_Generate_Keynamehelper4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Keynamehelper4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_keynamehelper4(inputs)
});
export { settings_reportingapikeys_generate_keynamehelper4 as "settings_reportingApiKeys_generate_keyNameHelper" }